export default "__VITE_ASSET__BdeBQ74a__"